/**
 * Two-layer admin routing: Classic (legacy UI) vs Enterprise (new shell).
 * @see documentation/ADMIN_APP_ENTERPRISE_IMPLEMENTATION_PLAN.md
 */

import { getEnvVarOptional } from './env';

export const CLASSIC_ADMIN_PREFIX = '/admin';
export const ENTERPRISE_ADMIN_BASE = '/admin/app';

/** Post-login default when no `from` redirect — set `VITE_ADMIN_DEFAULT_LAYER=enterprise` to land on `/admin/app`. */
export function getAdminPostLoginPath(): string {
  const layer = getEnvVarOptional('VITE_ADMIN_DEFAULT_LAYER').trim().toLowerCase();
  if (layer === 'enterprise') {
    return ENTERPRISE_ADMIN_BASE;
  }
  return `${CLASSIC_ADMIN_PREFIX}/dashboard`;
}

export type AdminLayerId = 'classic' | 'enterprise';

export function isEnterprisePath(pathname: string): boolean {
  return pathname === ENTERPRISE_ADMIN_BASE || pathname.startsWith(`${ENTERPRISE_ADMIN_BASE}/`);
}
